import { LitElement } from 'lit';

import { redispatchEvent } from '../../utils/events';

export class Component extends LitElement {
	protected emit = <T>(eventName: string, options?: CustomEventInit<T>) => {
		const event = new CustomEvent<T>(eventName, {
			bubbles: true,
			cancelable: true,
			composed: true,
			...options,
		});

		this.dispatchEvent(event);
	};

	/**
	 * Re-dispatches an event.
	 * This function is useful for forwarding non-composed events, such as `change`
	 * events.
	 *
	 * @example
	 * class MyInput extends LitElement {
	 *   render() {
	 *     return html`<input @change=${this.reemit}>`;
	 *   }
	 *
	 * }
	 *
	 * @param event The event to re-dispatch.
	 */
	protected reemit = (event: Event) => {
		redispatchEvent(this, event);
	};
}
